/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hearaboutofferother3Inputs */

const en__field_hearaboutofferother3 = /** @type {(inputs: _Field_Hearaboutofferother3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other`)
};

const de__field_hearaboutofferother3 = /** @type {(inputs: _Field_Hearaboutofferother3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstige Möglichkeiten`)
};

/**
* | output |
* | --- |
* | "other" |
*
* @param {_Field_Hearaboutofferother3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_hearaboutofferother3 = /** @type {((inputs?: _Field_Hearaboutofferother3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hearaboutofferother3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_hearaboutofferother3(inputs)
	return de__field_hearaboutofferother3(inputs)
});
export { _field_hearaboutofferother3 as "_field_hearAboutOfferOther" }